import Vue from "vue";
import Vuex from "vuex";
import * as axios from "axios";
import router from "../router";
import moment from "moment";

Vue.use(Vuex);

let baseUrl = process.env.VUE_APP_BASE_URL;
axios.defaults.headers.common["Accept-Language"] = window.localStorage.getItem(
  "language"
)
  ? window.localStorage.getItem("language")
  : "ru";

export default new Vuex.Store({
  state: {
    user: null,
    orderUser: null,
    staffUser: null,
    permissions: [],
    errors: [],
    alerts: [],
    locationsAll: [],
    locationsConcise: [],
    locations: [],
    locationSessions: [],
    locationOrders: [],
    locationGeo: null,
    locationId: null,
    currentLocation: null,
    summary: [],
    schedule: null,
    BASchedule: null,
    BAMultibookSchedule: null,
    BAMultibookOrder: null,
    events: [],
    locationSchedules: [],
    locationTranslations: null,
    orderComments: [],
    currentOrder: null,
    games: [],
    allowPasswordReset: false,
    language: window.localStorage.getItem("language")
      ? window.localStorage.getItem("language")
      : "ru",
    dashboards: null,
    orderId: null,
    errorMessage: null,
  },
  getters: {
    currentUser: (state) => state.user,
    orderUser: (state) => state.orderUser,
    staffUser: (state) => state.staffUser,
    permissions: (state) => state.permissions,
    checkPermission: (state) => (query) => {
      return state.permissions.find((permission) => permission === query);
    },
    locationsAll: (state) => state.locationsAll,
    locationsConcise: (state) => state.locationsConcise,
    locations: (state) => state.locations,
    locationSessions: (state) => state.locationSessions,
    locationOrders: (state) => state.locationOrders,
    locationGeo: (state) => state.locationGeo,
    errors: (state) => state.errors,
    alerts: (state) => state.alerts,
    location: (state) => state.currentLocation,
    locationId: (state) => state.locationId,
    summary: (state) => state.summary,
    schedule: (state) => state.schedule,
    BASchedule: (state) => state.BASchedule,
    BAMultibookSchedule: (state) => state.BAMultibookSchedule,
    BAMultibookOrder: (state) => state.BAMultibookOrder,
    events: (state) => state.events,
    locationSchedules: (state) => state.locationSchedules,
    locationTranslations: (state) => state.locationTranslations,
    orderComments: (state) => state.orderComments,
    currentOrder: (state) => state.currentOrder,
    games: (state) => state.games,
    language: (state) => state.language,
    dashboards: (state) => state.dashboards,
    dashboardsKeys: (state) => Object.keys(state.dashboards),
    orderId: (state) => state.orderId,
    errorMessage: (state) => state.errorMessage,
  },
  mutations: {
    errors: (state, payload) =>
      payload ? state.errors.push(payload) : (state.errors = []),
    alerts: (state, payload) =>
      payload ? state.alerts.push(payload) : (state.alerts = []),
    loadUser: (state, payload) => (state.user = payload),
    loadOrderUser: (state, payload) => (state.orderUser = payload),
    loadStaffUser: (state, payload) => (state.staffUser = payload),
    resetOrderUser: (state) => (state.orderUser = null),
    resetStaffUser: (state) => (state.staffUser = null),
    loadPermissions: (state, payload) => (state.permissions = payload),
    logOut: (state, payload) => (state.user = payload),
    loadLocationsAll: (state, payload) => (state.locationsAll = payload),
    loadLocationsConcise: (state, payload) =>
      (state.locationsConcise = payload),
    loadLocations: (state, payload) => (state.locations = payload),
    loadLocation: (state, payload) => {
      state.currentLocation = payload;
      state.locationId = payload.id;
    },
    loadLocationSessions: (state, payload) =>
      (state.locationSessions = payload),
    loadLocationOrders: (state, payload) => (state.locationOrders = payload),
    loadLocationGeo: (state, payload) => (state.locationGeo = payload),
    loadSummary: (state, payload) => (state.summary = payload),
    loadBASchedule: (state, payload) => (state.BASchedule = payload),
    loadBAMultibookSchedule: (state, payload) =>
      (state.BAMultibookSchedule = payload),
    loadBAMultibookOrder: (state, payload) =>
      (state.BAMultibookOrder = payload),
    loadEvents: (state, payload) => (state.events = payload),
    loadSchedule: (state, payload) => (state.schedule = payload),
    loadLocationSchedules: (state, payload) =>
      (state.locationSchedules = payload),
    setLocationTranslations: (state, payload) =>
      (state.locationTranslations = payload),
    loadBAOrderComments: (state, payload) => (state.orderComments = payload),
    loadCurrentOrder: (state, payload) => (state.currentOrder = payload),
    loadGames: (state, payload) => (state.games = payload),
    changeLanguage: (state, payload) => (state.language = payload),
    loadDashboards: (state, payload) => (state.dashboards = payload),
    loadOrderId: (state, payload) => (state.orderId = payload),
    loadErrorMessage: (state, payload) => (state.errorMessage = payload),
    resetOrderId: (state) => (state.orderId = null),
    resetErrorMessage: (state) => (state.errorMessage = null),
  },
  actions: {
    // USER

    async changeLanguage(context, payload) {
      context.commit("changeLanguage", payload);
      window.localStorage.setItem("language", payload);
      window.location.reload();
    },
    async logIn(context, payload) {
      try {
        let response = await axios.post(baseUrl + "/api/v2.1/login/", payload);
        window.localStorage.setItem("auth_token", response.data.token);
        context.commit("errors", null);
        context.dispatch("loadUser");
        router.push("locations");
      } catch (err) {
        context.commit("errors", err.response.data.detail);
      }
    },
    async loadPermissions(context) {
      axios.defaults.headers.common.Authorization =
        "Token " + window.localStorage.getItem("auth_token");
      let response = await axios.get(
        baseUrl + "/api/v2.1/loginjwt/permissions/"
      );

      context.commit("loadPermissions", response.data);
      context.dispatch("loadLocations");
    },
    async loadUser(context) {
      if (window.localStorage.getItem("auth_token")) {
        axios.defaults.headers.common.Authorization =
          "Token " + window.localStorage.getItem("auth_token");
        let response = await axios.get(baseUrl + "/api/v2.1/users/am/");
        context.commit("loadUser", response.data);
        context.dispatch("loadPermissions");
      }
    },
    async updateUser(context, payload) {
      let response = await axios.put(
        baseUrl + "/api/v2.1/users/" + payload.id + "/",
        payload.formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      context.commit("loadUser", response.data);
    },
    async loadOrderUser(context, user_id) {
      const response = await axios.get(baseUrl + `/api/v2.2/users/${user_id}/`);
      context.commit("loadOrderUser", response.data);
    },
    async loadStaffUser(context, user_id) {
      const response = await axios.get(baseUrl + `/api/v2.2/users/${user_id}/`);
      context.commit("loadStaffUser", response.data);
    },
    resetStateOrderUser(context) {
      context.commit("resetOrderUser");
    },
    resetStateStaffUser(context) {
      context.commit("resetStaffUser");
    },
    async logOut(context) {
      if (window.localStorage.getItem("auth_token")) {
        window.localStorage.removeItem("auth_token");
      }
      context.commit("logOut", null);
      context.commit("loadUser", null);
      context.commit("loadPermissions", []);
      context.commit("loadLocationsConcise", []);
      context.commit("loadLocations", []);
      router.push({
        name: "login",
      });
    },
    async requestToResetPassword(context, payload) {
      try {
        let response = await axios.post(
          baseUrl + "/api/v2.1/users/password_reset/",
          payload
        );
        context.commit("errors", null);
        context.commit(
          "alerts",
          "Ссылка на востановление пароля отправлена на указанную почту."
        );
      } catch (err) {
        context.commit("alerts", null);
        context.commit("errors", err.response.data.detail);
      }
    },
    async resetPassword(context, payload) {
      try {
        await axios.post(
          baseUrl + "/api/v2.1/users/password_reset/" + payload.key + "/",
          payload.data
        );
        context.commit("errors", null);
        context.commit("alerts", "Пароль успешно изменен");
        router.push({
          name: "login",
        });
      } catch (err) {
        context.commit("alerts", null);
        context.commit("errors", err.response.data.detail);
      }
    },
    async checkResetPasswordHash(context, payload) {
      return await axios.get(
        baseUrl + "/api/v2.1/users/password_reset/" + payload + "/"
      );
    },

    // Locations

    async loadLocations(context) {
      axios.defaults.headers.common.Authorization =
        "Token " + window.localStorage.getItem("auth_token");
      let response = await axios.get(baseUrl + "/api/v2.1/locations/my/");
      context.commit("loadLocations", response.data);
      // context.dispatch('loadLocationsConcise');
    },
    async loadLocationsAll(context) {
      axios.defaults.headers.common.Authorization =
        "Token " + window.localStorage.getItem("auth_token");
      let response = await axios.get(baseUrl + "/api/v2.1/locations/");
      context.commit("loadLocationsAll", response.data);
    },
    async loadLocationsConcise(context) {
      axios.defaults.headers.common.Authorization =
        "Token " + window.localStorage.getItem("auth_token");
      let response = await axios.get(
        baseUrl + "/api/v2.1/locations/concise_list/"
      );
      context.commit("loadLocationsConcise", response.data);
    },
    async loadLocation(context, location_id) {
      axios.defaults.headers.common.Authorization =
        "Token " + window.localStorage.getItem("auth_token");
      await axios
        .get(baseUrl + "/api/v2.1/locations/" + location_id + "/")
        .then((response) => {
          if (response.data.languages) {
            response.data.languages.forEach((lang) => {
              if (
                !response.data.translations.find((el) => {
                  return el.language == lang;
                })
              ) {
                response.data.translations.push({
                  language: lang,
                });
              }
            });
            let locationTranslations = response.data.translations.find((el) => {
              return el.language === this.state.language;
            });
            context.commit("setLocationTranslations", locationTranslations);
          }
          context.commit("loadLocation", response.data);
        });
    },
    async updateLocationInfo(context, payload) {
      await axios
        .put(baseUrl + `/api/v2.1/locations/${this.state.locationId}/`, payload)
        .then((response) => {
          context.commit("loadLocation", response.data);
        });
    },
    async loadLocationSessions(context, payload) {
      const response = await axios.get(
        baseUrl +
          `/api/v2.1/locations/${this.state.locationId}/launcher_sessions/?${payload}`
      );
      context.commit("loadLocationSessions", response.data);
    },
    async getSessionsCSV(context, payload) {
      return await axios.get(
        baseUrl +
          `/api/v2.1/locations/${this.state.locationId}/launcher_sessions/?${
            payload ? payload + "&format=csv" : "&format=csv"
          }`
      );
    },
    async loadLocationOrders(context, payload) {
      const response = await axios.get(
        baseUrl +
          `/api/v2.1/locations/${this.state.locationId}/orders/?${payload}`
      );
      context.commit("loadLocationOrders", response.data);
    },
    async getOrdersCSV(context, payload) {
      return await axios.get(
        baseUrl +
          `/api/v2.1/locations/${this.state.locationId}/orders/?${
            payload ? payload + "&format=csv" : "&format=csv"
          }`
      );
    },
    async loadLocationGeo(context) {
      const response = await axios.get(baseUrl + "/api/v2.1/geo/");
      context.commit("loadLocationGeo", response.data);
    },

    // Payments

    async getPayments(context, payload) {
      return await axios.get(
        baseUrl +
          `/api/v2.1/locations/${this.state.locationId}/payments/?${payload}`
      );
    },
    async getPaymentsCSV(context, payload) {
      return await axios.get(
        baseUrl +
          `/api/v2.1/locations/${this.state.locationId}/payments/?${
            payload ? payload + "&csv=true" : "&csv=true"
          }`
      );
    },
    async setPayment(context, payload) {
      return await axios.post(
        baseUrl + `/api/v2.1/locations/${this.state.locationId}/payments/`,
        payload
      );
    },
    async hidePayment(context, payload) {
      return await axios.patch(
        baseUrl + `/api/v2.1/payment/${payload}/actual/`
      );
    },

    // Transactions

    async getTransactions(context, payload) {
      // axios.defaults.headers.common.Authorization = 'Token ' + window.localStorage.getItem('auth_token');
      return await axios.get(baseUrl + `/api/v2.1/transactions/?${payload}`);
    },
    async setDispute(context, payload) {
      return await axios.post(
        baseUrl + `/api/v2.1/transactions/${payload.id}/dispute/`,
        payload.data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    },
    async setTransaction(context, payload) {
      return await axios.post(
        baseUrl + `/api/v2.1/transactions/create_transaction/`,
        payload
      );
    },
    async refillLocationAccount(context, payload) {
      return await axios.post(
          baseUrl + `/api/v2.2/locations/${this.state.locationId}/refill/`,
          payload
      );
    },
    async checkPayment(context, payload) {
      return await axios.post(
          baseUrl + `/api/v2.2/locations/${this.state.locationId}/check_payment/`,
          payload
      );
    },

    // Search

    async getSearchOrders(context, payload) {
      return await axios.get(
        baseUrl +
          `/api/v2.2/orders/search/?limit=${payload.limit}&offset=${payload.offset}&phone=${payload.phone}`
      );
    },

    // Booking-admin

    async loadSummary(context, payload) {
      axios.defaults.headers.common.Authorization =
        "Token " + window.localStorage.getItem("auth_token");
      let response = await axios.get(
        baseUrl +
          `/api/v2.1/locations/${payload.location_id}/summary/?date=${payload.date}`
      );
      let summary = response.data.map((el) => {
        return {
          date: moment.parseZone(el.date),
          dateString: moment.parseZone(el.date).format("D MMMM, dddd"),
          reserved: el.places.join(" + "),
        };
      });
      if (!payload.with_archived) {
        summary = summary.filter(
          (el) =>
            moment.parseZone().startOf("day") <=
            moment.parseZone(el.date).startOf("day")
        );
        context.commit("loadSummary", summary);
      } else {
        context.commit("loadSummary", summary);
      }
    },
    async loadBASchedule(context, payload) {
      axios.defaults.headers.common.Authorization =
        "Token " + window.localStorage.getItem("auth_token");
      await axios
        .get(
          baseUrl +
            `/api/v2.1/playgrounds/${payload.playground_id}/schedule/?date=${payload.selected_date}&orders=1`
        )
        .then((response) => {
          context.commit("loadBASchedule", response.data);
        });
    },
    async loadBAMultibookSchedule(context, date) {
      axios.defaults.headers.common.Authorization =
        "Token " + window.localStorage.getItem("auth_token");
      await axios
        .get(
          baseUrl +
            `/api/v2.2/locations/${this.state.locationId}/schedule_multi/?date=${date}`
        )
        .then((response) => {
          context.commit("loadBAMultibookSchedule", response.data);
        });
    },
    async loadBAMultibookOrder(context, orderId) {
      axios.defaults.headers.common.Authorization =
        "Token " + window.localStorage.getItem("auth_token");
      await axios
        .get(baseUrl + `/api/v2.2/multibooking/${orderId}/`)
        .then((response) => {
          context.commit("loadBAMultibookOrder", response.data);
        });
    },
    async loadEvents(context, payload) {
      await axios
        .get(
          baseUrl +
            `/api/v2/limepay/events/?location_id=${
              payload.id
            }&date_from=${moment.parseZone(payload.date).format("YYYY-MM-DD")}`
        )
        .then((response) => {
          context.commit("loadEvents", response.data.goods);
        });
    },
    async loadCurrentOrder(context, order_id) {
      return await axios
        .get(baseUrl + `/api/v2.2/orders/${order_id}/`)
        .then((response) => {
          context.commit("loadCurrentOrder", response.data);
        });
    },
    async removeBAOrder(context, order_id) {
      await axios.delete(baseUrl + `/api/v2.1/booking/${order_id}/`);
    },
    async payBAOrder(context, payload) {
      await axios.post(
        baseUrl + `/api/v2.1/booking/${payload.order_id}/pay/`,
        payload.payment
      );
    },
    async loadBAOrderComments(context, order_id) {
      axios.defaults.headers.common.Authorization =
        "Token " + window.localStorage.getItem("auth_token");
      return await axios.get(
        baseUrl + `/api/v2.1/booking/${order_id}/comments/`
      );
    },
    async checkCoupon(context, code_data) {
      return await axios.post(baseUrl + `/api/v2.1/check_coupon/`, code_data);
    },
    async createOrder(context, order_data) {
      return await axios
        .post(baseUrl + `/api/v2.1/booking/`, order_data)
        .then((response) => {
          const orderId = response.data.id;
          context.commit("loadOrderId", orderId);
        })
        .catch((error) => {
          if (
            error.response.request.status !== 200 ||
            error.response.request.status !== 201
          ) {
            const errorMessage = error.response.data;
            context.commit("loadErrorMessage", errorMessage);
          }
        });
    },
    async createOrderMulti(context, order_data) {
      return await axios
        .post(`${baseUrl}/api/v2.2/multibooking/`, order_data)
        .then((response) => {
          const orderId = response.data.order_id;
          context.commit("loadOrderId", orderId);
        })
        .catch((error) => {
          if (
            error.response.request.status !== 200 ||
            error.response.request.status !== 201
          ) {
            const errorMessage = error.response.data;
            context.commit("loadErrorMessage", errorMessage);
          }
        });
    },
    async editOrder(context, order_data) {
      return await axios.put(
        baseUrl + `/api/v2.1/booking/${order_data.id}/`,
        order_data
      );
    },
    async editOrderMulti(context, order_data) {
      return await axios.post(
        baseUrl + `/api/v2.2/multibooking/${order_data.id}/update_part/`,
        order_data
      );
    },
    async checkSchedule(context, item) {
      return await axios.post(baseUrl + `/api/v2.1/schedule/check/`, item);
    },
    async loadGamesByPlaygroundId(context, playground_id) {
      axios.defaults.headers.common.Authorization =
        "Token " + window.localStorage.getItem("auth_token");
      await axios
        .get(
          baseUrl + `/api/v2.2/playgrounds/${playground_id}/games_for_booking/`
        )
        .then((response) => {
          context.commit("loadGames", response.data);
        });
    },
    resetState(context) {
      context.commit("resetOrderId");
      context.commit("resetErrorMessage");
    },

    // LK

    async loadLocationSchedules(context, location_id) {
      axios.defaults.headers.common.Authorization =
        "Token " + window.localStorage.getItem("auth_token");
      let response = await axios.get(
        baseUrl + "/api/v2.1/schedule/?location=" + location_id
      );
      context.commit("loadLocationSchedules", response.data);
    },
    async createGroup(context, groupName) {
      await axios.post(
        baseUrl + `/api/v2.1/locations/${this.state.locationId}/groups/`,
        groupName
      );
      context.dispatch("loadLocation", this.state.locationId);
    },
    async editGroup(context, group) {
      await axios.put(
        baseUrl + `/api/v2.1/locations/${this.state.locationId}/groups/`,
        group
      );
      context.dispatch("loadLocation", this.state.locationId);
    },
    async changePlaygroundGroup(context, payload) {
      await axios.put(
        baseUrl + `/api/v2.1/playgrounds/${payload.playgroundId}/group/`,
        {
          group: payload.groupId,
        }
      );
      context.dispatch("loadLocation", this.state.locationId);
    },
    async removeGroup(context, groupId) {
      await axios.delete(
        baseUrl +
          `/api/v2.1/locations/${this.state.locationId}/groups/${groupId}`
      );
      context.dispatch("loadLocation", this.state.locationId);
    },
    async loadSchedule(context, scheduleId) {
      axios.defaults.headers.common.Authorization =
        "Token " + window.localStorage.getItem("auth_token");
      let response = await axios.get(
        baseUrl + "/api/v2.1/schedule/" + scheduleId + "/"
      );
      context.commit("loadSchedule", response.data);
    },
    async updateScheduleInfo(context, payload) {
      try {
        let response = await axios.put(
          baseUrl + `/api/v2.1/schedule/${this.state.schedule.id}/`,
          payload
        );
        context.commit("errors", null);
      } catch (err) {
        context.commit("errors", null);
        let error = null;

        for (let item of err.response.data.items[0].pricing) {
          for (let key of Object.keys(item)) {
            if (typeof item[key] === "string") {
              error = item[key];
              break;
            } else if (Array.isArray(item[key])) {
              error = item[key].find((el) => typeof el === "string");
              break;
            }
          }
          if (error) break;
        }
        context.commit("errors", error);
      }
    },
    async changeScheduleStatus(context, scheduleId) {
      try {
        let response = await axios.patch(
          baseUrl + `/api/v2.1/schedule/${scheduleId}/visible/`
        );
        context.commit("errors", null);
        if (this.state.currentLocation) {
          context.dispatch("loadLocationSchedules", this.state.locationId);
        }
        if (this.state.schedule) {
          context.dispatch("loadSchedule", this.state.schedule.id);
        }
      } catch (err) {
        context.commit("errors", err.response.data.start_dt);
      }
    },
    async cloneSchedule(context, scheduleId) {
      await axios.post(baseUrl + `/api/v2.1/schedule/${scheduleId}/clone/`);
      context.dispatch("loadLocationSchedules", this.state.locationId);
    },
    async createSchedule(context, payload) {
      let response = await axios.post(baseUrl + `/api/v2.1/schedule/`, payload);
      router.push({
        name: "schedule",
        params: {
          schedule_id: response.data.id,
          location_id: this.state.locationId,
        },
      });
    },
    async removeSchedule(context, payload) {
      await axios.delete(baseUrl + `/api/v2.1/schedule/${payload.id}/`);
      if (payload.redirect) {
        if (this.state.locationId) {
          router.push({
            name: "location",
            params: {
              location_id: this.state.locationId,
            },
          });
        } else {
          router.push({
            name: "locations",
          });
        }
      } else {
        context.dispatch("loadLocationSchedules", this.state.locationId);
      }
    },

    // Control tech sessions

    async allowSession(context, payload) {
      return await axios.post(
        baseUrl + `/api/v2.1/playgrounds/${payload.id}/tech_sessions/`,
        payload.data
      );
    },
    async disallowSession(context, playground_id) {
      return await axios.delete(
        baseUrl + `/api/v2.1/playgrounds/${playground_id}/tech_sessions/`
      );
    },
    async createToken(context, payload) {
      return await axios.post(
        baseUrl + "/api/v2.2/playgrounds/create_token/",
        payload
      );
    },

    // Early booking

    async getEarlyBookingConditions(context, payload) {
      return await axios.get(
        baseUrl + `/api/v2.1/locations/${this.state.locationId}/early_booking/`
      );
    },
    async createEarlyBookingCondition(context, payload) {
      return await axios.post(
        baseUrl + `/api/v2.1/locations/${this.state.locationId}/early_booking/`,
        payload
      );
    },
    async editEarlyBookingCondition(context, payload) {
      return await axios.put(
        baseUrl + `/api/v2.1/early_booking_conditions/${payload.id}/`,
        payload
      );
    },
    async removeEarlyBookingCondition(context, payload) {
      return await axios.delete(
        baseUrl + `/api/v2.1/early_booking_conditions/${payload.id}/`
      );
    },

    // Webhooks

    async getWebHooks(context, payload) {
      return await axios.get(
        baseUrl + `/api/v2.1/locations/${this.state.locationId}/webhooks/`
      );
    },
    async createWebHook(context, payload) {
      return await axios.post(
        baseUrl + `/api/v2.1/locations/${this.state.locationId}/webhooks/`,
        payload
      );
    },
    async editWebHook(context, payload) {
      return await axios.put(
        baseUrl + `/api/v2.1/webhook/${payload.id}/`,
        payload
      );
    },
    async removeWebHook(context, payload) {
      return await axios.delete(baseUrl + `/api/v2.1/webhook/${payload.id}/`);
    },
    async loadDashboards(context, payload) {
      let result = await axios.get(baseUrl + "/api/v2.1/dashboards/");
      context.commit("loadDashboards", result.data);
    },
  },
});
